import { ClientType } from '@common/model/client/clientType';
import { TabItem, TabItemId, Tabs, TabsTokens } from '@cp/ds/src/components/tabs';
import { useTheme } from '@cp/ds/src/hooks';
import { useFormContext } from 'react-hook-form';
import { ProcessingAndReviewsFiltersType } from '../processingAndReviews';

const items: TabItem[] = [
  {
    id: ClientType.Employer,
    label: 'От нанимателей',
    body: null,
  },
  {
    id: ClientType.Specialist,
    label: 'От специалистов',
    body: null,
  },
];

export const ClientTypeField = () => {
  const theme = useTheme();
  const form = useFormContext<ProcessingAndReviewsFiltersType>();
  const changeTypeOfClientHandle = (itemId: TabItemId) => form.setValue('clientType', itemId as number);

  return (
    <Tabs
      itemId={form.getValues('clientType')}
      itemSx={{
        [TabsTokens.IndicatorColor]: theme.palette['brand pink hover'],
        [TabsTokens.ActiveTextColor]: theme.palette['brand pink hover'],
      }}
      items={items}
      onItemChange={changeTypeOfClientHandle}
      sx={{ width: 'max-content' }}
    />
  );
};
